/**
 * Common Media Streaming Format
 *
 * @internal
 */
export const CmStreamingFormat = {
    /**
     * MPEG DASH
     */
    DASH: 'd',
    /**
     * HTTP Live Streaming (HLS)
     */
    HLS: 'h',
    /**
     * Smooth Streaming
     */
    SMOOTH: 's',
    /**
     * Other
     */
    OTHER: 'o',
};
//# sourceMappingURL=CmStreamingFormat.js.map